import Livekit from '@/pages/Livekit';

import { Sheet, SheetContent, SheetHeader, SheetTitle } from '@/components/ui/sheet';

import { useEventHandler } from '@/hooks/use-event-handler';
import { useToggle } from '@/hooks/use-toggle';

export const TestAgentWeb = () => {
  const { state, open, toggle } = useToggle();

  useEventHandler({ name: 'agent:test:web', eventHandler: open });

  return (
    <div className="ml-auto flex items-center gap-2">
      <Sheet open={state} onOpenChange={toggle}>
        <SheetContent side="right" className="w-full sm:max-w-md overflow-y-auto p-0">
          <SheetHeader className="p-4 w-full relative">
            <SheetTitle>Test call</SheetTitle>
          </SheetHeader>
          <Livekit />
        </SheetContent>
      </Sheet>
    </div>
  );
};
